import React from 'react'
import { StyleSheet, TouchableOpacity, View, Image, Platform } from 'react-native'

export default function HeaderImageView( { source=null, onPress, style=null } ) {
  return (
    <TouchableOpacity onPress={onPress} style={[styles.icon, style]}>
      <View style={styles.view}>
        { source && <Image source={source} style={{ width: 30, height: 50, resizeMode: 'contain' }} /> }
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  view: {
    height: 24,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end'
    // width: 24,
  },
  icon: {
    marginRight : Platform.OS === 'web' ? 14 : 0,
    // marginVertical: 6
  }
})
